import { Input } from '@/components/ui/input'
import { ChangeEvent, InputHTMLAttributes, useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { MinusIcon, PlusIcon } from 'lucide-react'

export default function QuantityField(
  props: {
    defaultValue?: number
    min?: number
    max?: number
    step?: number
    onChange?: (value: number) => void
  } & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>,
) {
  const {
    min: minProp,
    max: maxProp,
    step: stepProp,
    defaultValue,
    onChange,
    ...inputProps
  } = props
  const min = minProp ?? 1
  const max = maxProp ?? 100
  const step = stepProp ?? 1
  const [quantity, setQuantity] = useState(props.defaultValue ?? min ?? 1)

  function mutateQuantity(amount: number) {
    setQuantity(quantity + amount)
  }

  function validQuantity(newQuantity: number) {
    return newQuantity >= min && newQuantity <= max
  }

  useEffect(() => {
    onChange?.(quantity)
  }, [quantity, onChange])

  return (
    <div className={'flex gap-2 mb-2'}>
      <Input
        type={'number'}
        name={'quantity'}
        min={min}
        max={max}
        step={step}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setQuantity(parseInt(e.target.value))
        }}
        value={quantity}
        {...inputProps}
      />
      <Button
        className={'rounded-full px-2'}
        variant={'outline'}
        type={'button'}
        disabled={!validQuantity(quantity - 1)}
      >
        <MinusIcon onClick={() => mutateQuantity(-1)} />
      </Button>
      <Button
        className={'rounded-full px-2'}
        type={'button'}
        disabled={!validQuantity(quantity + 1)}
      >
        <PlusIcon onClick={() => mutateQuantity(1)} />
      </Button>
    </div>
  )
}
